import { render, staticRenderFns } from "./ManageBookingsItem.vue?vue&type=template&id=1148dc42"
import script from "./ManageBookingsItem.vue?vue&type=script&lang=js"
export * from "./ManageBookingsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports